import React from 'react';





const SignupPage = () => {


    return (

        <a href='./Login'>Yahan Structure Hoga ji Signup kaa login kaa </a>
    );



};
export default SignupPage;